import { retrieveAppointments } from "../api/api";
import { SequenceManagerAction } from "./SequenceManagerAction";

const DeliveryAppointmentAction = {
    RETRIEVE_APPOINTMENTS_SUCCESS: 'RETRIEVE_APPOINTMENTS_SUCCESS',
    RETRIEVE_APPOINTMENTS_FAILURE: 'RETRIEVE_APPOINTMENTS_FAILURE',
    UPDATE_SELECTED_DATE: 'UPDATE_SELECTED_DATE'
}

const retrieveAppointmentsSlots = () => {
    return function (dispatch: any) {
        retrieveAppointments().then((response) => {
            dispatch({ type: DeliveryAppointmentAction.RETRIEVE_APPOINTMENTS_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: DeliveryAppointmentAction.RETRIEVE_APPOINTMENTS_FAILURE, payload: error.response });
                // dispatch({type: SequenceManagerAction.GENERIC_ERROR, payload:error});
            })
    }
}

const updateSelectedDate = (data: any) => {
    return function (dispatch: any) {
        dispatch({ type: DeliveryAppointmentAction.UPDATE_SELECTED_DATE, payload: data });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['DeliveryAppointment'] });
    }
}
export { retrieveAppointmentsSlots, DeliveryAppointmentAction, updateSelectedDate };